var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleSheet = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4C5773",
  stroke: "#4C5773",
  d: "M12.884 5.53c.234.235.366.553.366.884V13c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h4.586c.331 0 .65.132.884.366l3.414 3.414ZM9 2.354V2.25H4a.75.75 0 0 0-.75.75v10c0 .414.336.75.75.75h8a.75.75 0 0 0 .75-.75V6h-.104l-.853-.854-1.94-1.939L9 2.354Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#26A668",
  fillRule: "evenodd",
  d: "M4 1.25A1.75 1.75 0 0 0 2.25 3v10c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 13.75 13V6.414c0-.464-.184-.909-.513-1.237L9.823 1.763a1.75 1.75 0 0 0-1.237-.513H4Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#92D3B4",
  fillRule: "evenodd",
  d: "M13.7 6H9.5a.5.5 0 0 1-.5-.5V1.3c.31.075.595.234.823.463l3.414 3.414c.23.229.388.514.463.823Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.5 8.5h5v1h-5v-1Zm4 2h-4v1h4v-1Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleSheet);
export default ForwardRef;